import { Role } from '@/shared/roles/role';
import { User } from '@/shared/user';
import { State } from '@/stores/users/state';
import { MutationTree } from 'vuex';

export class Mutations implements MutationTree<State> {
    [key: string]: (state: State, payload: any) => any;

    public setUsers = (state: State, users: Array<User>) => {
        state.users = users;
    }

    public setLegalAdvisorUsers = (state: State, users: Array<User>) => {
        state.legalAdvisorUsers = users;
    }

    public setAppointmentBookerUsers = (state: State, users: Array<User>) => {
        state.appointmentBookerUsers = users;
    }

    public setInteractionAuthorUsers = (state: State, users: Array<User>) => {
        state.interactionAuthorUsers = users;
    }

    public setAssignedTaskUsers = (state: State, users: Array<User>) => {
        state.assignedTaskUsers = users;
    }

    public setCompletedTaskUsers = (state: State, users: Array<User>) => {
        state.completedTaskUsers = users;
    }

    public setAccountAuthorUsers = (state: State, users: Array<User>) => {
        state.accountAuthorUsers = users;
    }

    public setAssignedCallUsers = (state: State, users: Array<User>) => {
        state.assignedCallUsers = users;
    }

    public setAccountAccessUsers = (state: State, users: Array<User>) => {
        state.accountAccessUsers = users;
    }

    public setTargetUsers = (state: State, users: Array<User>) => {
        state.targetUsers = users;
    }

    public setRoles = (state: State, roles: Array<Role>) => {
        state.roles = roles;
    }
}
